module.exports = __webpack_public_path__ + "static/assets/97b13b52e372543be9a6ff8d6a30d0af.svg";